<template>
    <div class="step1-container">
        <!-- Project Name -->
        <!-- <div class="form-field">
            <form-input
                type="text"
                :errors="v$.project_name"
                v-model="project.project_name"
                id="project_name"
                :label="$t('fields.project_name')"
                :required="true"
                placeholder="Type the exact project name as provided by BD e.g., 'Tourism Accelerator'"
            />
        </div> -->

        <!-- Title -->
        <div class="form-field">
            <form-input
                type="text"
                :errors="v$?.title"
                v-model="project.title"
                id="title"
                :label="$t('fields.BD_approved_name')"
                :required="true"
                :placeholder="
                    $t(
                        'fields.type_the_exact_project_name_as_provided_by_BD_e_g_tourism_accelerator',
                    )
                "
            />
        </div>

        <!-- Date Fields Row -->
        <div class="row m-0 mt-2">
            <!-- Start Date -->
            <div class="col-md-6 ps-0">
                <form-date-picker
                    v-model="project.start_date"
                    id="start_date"
                    name="start_date"
                    :label="$t('fields.start_date')"
                    :required="true"
                    :errors="v$?.start_date"
                    :placeholder="
                        $t('placeholders.when_does_the_project_kickoff')
                    "
                />
                <div v-if="formErrors.start_date" class="error-message">
                    {{ formErrors.start_date[0] }}
                </div>
            </div>

            <!-- End Date -->
            <div class="col-md-6 ps-0">
                <form-date-picker
                    v-model="project.end_date"
                    id="end_date"
                    name="end_date"
                    :label="$t('fields.end_date')"
                    :required="true"
                    :errors="v$?.end_date"
                    :placeholder="
                        $t('placeholders.when_does_the_project_close')
                    "
                    :disabled-date="disabledEndDate"
                />
                <div v-if="formErrors.end_date" class="error-message">
                    {{ formErrors.end_date[0] }}
                </div>
            </div>
        </div>
        <div class="row m-0 mt-2">
            <div class="col-md-6 mt-2 ps-0">
                <form-input
                    name="secondary_docs_count"
                    type="number"
                    :errors="v$?.secondary_docs_count"
                    v-model.number="project.secondary_docs_count"
                    label="Estimated Project Documents for Upload"
                    :required="true"
                    placeholder="Estimated Project Documents for Upload (excluding case study, proposal, EM Guide)"
                    min="1"
                    max="100"
                    :hasTooltip="true"
                    :tooltipText="'Number of documents for secondary document type to be uploaded'"
                    onkeypress="
                        return event.charCode >= 48 && event.charCode <= 57;
                    "
                    @input="
                        (e) => {
                            const value = Number(e.target.value);
                            if (value < 0) e.target.value = 0;
                            if (value > 10000) e.target.value = 0;
                            project.secondary_docs_count = e.target.value;
                        }
                    "
                />
            </div>
            <!--document_type_ids  -->
            <!-- <div class="col-md-6 ps-0">
                <form-el-select
                    name="document_type_ids"
                    :multiple="true"
                    :options="documentTypesForSelect"
                    :label="$t('fields.document_type')"
                    :model="project"
                    :errors="formErrors.document_type_ids"
                    label-field="name"
                    :required="true"
                    :placeholder="$t('placeholders.select_document_types')"
                    :hasTooltip="true"
                    :tooltipText="'Select the document types that will be needed for this project'"
                />
            </div> -->

            <!--business_unit  -->
            <div class="col-md-6 ps-0 mt-2">
                <form-el-select
                    name="business_units"
                    :multiple="true"
                    :options="businessUnitsForSelect"
                    :label="$t('fields.business_unit')"
                    :model="project"
                    :errors="formErrors"
                    label-field="fields.business_unit_ids"
                    :required="true"
                    :clearable="false"
                    :placeholder="$t('placeholders.select_business_units')"
                    @deselected="handleBusinessUnitChange"
                    @select="handleBusinessUnitSelected"
                />
            </div>
            <!-- Charge Code -->
        </div>
        <div class="row m-0 mt-2">
            <!--managed_service  -->
            <div class="col-md-6 ps-0">
                <form-el-select
                    name="managed_service_id"
                    :options="managedServiceForSelect"
                    :multiple="false"
                    :label="$t('fields.managed_service')"
                    :model="project"
                    :errors="
                        project?.business_units?.includes(2) ? formErrors : null
                    "
                    label-field="fields.managed_service"
                    :required="true"
                    :clearable="false"
                    :placeholder="$t('placeholders.managed_service')"
                    :disabled="!project?.business_units?.includes(2)"
                />
            </div>
            <!--service_line_ids  -->
            <!-- <div class="col-md-6 ps-0">
                <form-el-select
                    name="service_line_ids"
                    :options="serviceLinesForSelect"
                    :multiple="true"
                    :label="$t('fields.service_line_ids')"
                    :model="project"
                    :errors="formErrors"
                    label-field="fields.service_line_ids"
                    :required="true"
                    :clearable="false"
                    :placeholder="$t('placeholders.service_line_ids')"
                />
            </div> -->

            <!--digital_solution  -->
            <div class="col-md-6 ps-0">
                <form-el-select
                    name="digital_solution_id"
                    :options="digitalSolutionForSelect"
                    :label="$t('fields.digital_solution')"
                    :model="project"
                    :errors="
                        project?.business_units?.includes(2) ? formErrors : null
                    "
                    label-field="fields.digital_solution"
                    :required="
                        project?.business_units?.includes(2) ? true : false
                    "
                    :disabled="!project?.business_units?.includes(2)"
                    clearable
                />
            </div>
        </div>

        <div class="row m-0 mt-2">
            <!--offerings  -->
            <div class="col-md-6 ps-0">
                <form-el-select
                    name="offering_ids"
                    :options="serviceOfferingForSelect"
                    :label="$t('fields.service_offering')"
                    :model="project"
                    :errors="formErrors"
                    label-field="fields.service_offering"
                    :required="true"
                    :multiple="true"
                    clearable
                />
            </div>

            <!--business Domain  -->
            <div class="col-md-6 ps-0">
                <form-el-select
                    name="business_domain_ids"
                    :options="businessDomainsForSelect"
                    :multiple="true"
                    :label="$t('fields.business_domain')"
                    :model="project"
                    :errors="formErrors"
                    label-field="fields.business_domain"
                    :required="true"
                    :disabled="true"
                    :clearable="false"
                    :placeholder="
                        $t('placeholders.selected_based_on_service_offering')
                    "
                    @deselected="handleBusinessDomainDeselected"
                    readonly
                />
            </div>
            <div class="col-md-6 ps-0 mt-2">
                <form-input
                    type="text"
                    :errors="v$?.charge_code"
                    v-model="project.charge_code"
                    id="charge_code"
                    :label="$t('fields.charge_code')"
                    :required="true"
                    placeholder="Type the charge or project code e.g., STA220021"
                />
            </div>
        </div>

        <div class="row m-0 mt-2">
            <!-- Has Tracks -->
            <div class="col-md-6 ps-0">
                <div class="d-flex align-items-center mb-2">
                    <label class="form-label me-2 mb-0">
                        {{ $t("fields.has_multiple_tracks") }}
                    </label>
                    <TooltipIcon
                        :content="
                            $t(
                                'tooltips.Tracks are parallel workstreams within the project, each led by a manager',
                            )
                        "
                    />
                </div>

                <div class="d-flex gap-2">
                    <!-- YES Option -->
                    <label
                        class="option-card flex-grow-1"
                        :class="{
                            'is-selected': project.has_multiple_tracks === true,
                        }"
                    >
                        <span class="option-label">Yes</span>
                        <input
                            type="radio"
                            v-model="project.has_multiple_tracks"
                            :value="true"
                            class="visually-hidden"
                        />
                        <span class="option-radio" aria-hidden="true"></span>
                    </label>

                    <!-- NO Option -->
                    <label
                        class="option-card flex-grow-1"
                        :class="{
                            'is-selected':
                                project.has_multiple_tracks === false,
                        }"
                    >
                        <span class="option-label">No</span>
                        <input
                            type="radio"
                            v-model="project.has_multiple_tracks"
                            :value="false"
                            class="visually-hidden"
                        />
                        <span class="option-radio" aria-hidden="true"></span>
                    </label>
                </div>
            </div>

            <!-- Number of Tracks -->
            <div class="col-md-6 ps-0" v-if="project.has_multiple_tracks">
                <form-input
                    type="number"
                    :errors="v$?.tracksCount"
                    v-model.number="project.tracksCount"
                    name="tracksCount"
                    id="num_of_tracks"
                    :label="$t('fields.num_of_tracks')"
                    :required="true"
                    :placeholder="
                        $t(
                            'placeholders.Please select the Number of tracks for the Project',
                        )
                    "
                    :min="1"
                    :max="10"
                    @input="
                        (e) => {
                            console.log('input', e.target.value);
                            // Prevent typing zero or less
                            if (e.target.value < 1) {
                                project.tracksCount = 1;
                                e.target.value = 1;
                            }
                        }
                    "
                    @keydown="
                        (event) => {
                            // Prevent typing '0' as the first character
                            if (
                                (event.key === '0' || event.key === 0) &&
                                (!event.target.value ||
                                    event.target.value === '0')
                            ) {
                                event.preventDefault();
                            }
                        }
                    "
                />
            </div>
        </div>

        <!-- Dynamic track inputs -->
        <div
            class="row m-0 mt-2"
            v-if="
                project?.has_multiple_tracks &&
                Number.isInteger(project?.tracksCount) &&
                project.tracksCount > 0 &&
                project.tracksCount <= 10
            "
        >
            <div
                v-for="index in project.tracksCount"
                :key="index"
                class="col-md-6 ps-0"
            >
                <div class="d-flex align-items-start gap-2 track-input-wrapper">
                    <div class="flex-grow-1">
                        <form-input
                            type="text"
                            v-model="project.tracks[index - 1]"
                            :errors="trackInputErrors(index - 1)"
                            name="tracks"
                            :id="'track_' + index"
                            :label="$t('fields.track') + ' ' + index"
                            :required="true"
                            :placeholder="
                                $t('placeholders.enter_name_for_track') +
                                ' ' +
                                index +
                                ' ' +
                                $t(
                                    'placeholders.e_g_fashion_track_for_policy_labs',
                                )
                            "
                        />
                    </div>
                    <div class="delete-icon-container">
                        <DeleteIcon
                            class="cursor-pointer"
                            @click="deleteTrack(index - 1)"
                            width="20"
                            height="20"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Duplicate tracks validation message -->
        <div v-if="hasDuplicateTracks" class="duplicate-tracks-warning mt-3">
            <div
                class="alert alert-warning d-flex align-items-center"
                role="alert"
            >
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="me-2"
                >
                    <path
                        d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <div>
                    <strong>Duplicate Track Names Detected!</strong><br />
                    <small
                        >Please ensure all track names are unique. Track names
                        are case-insensitive.</small
                    >
                </div>
            </div>
        </div>
    </div>

    <el-dialog
        v-model="openBusinessUnitEditMessage"
        style="width: 30% !important"
        class="request-doc-dialog client-dialog standalone-dialog"
        align-center
        destroy-on-close
    >
        <div class="row g-3 text-center">
            <!-- Success Message -->

            <svg
                width="96"
                height="96"
                viewBox="0 0 96 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M48 0C60.8096 0.227335 73.0163 5.3844 81.9933 14.3614C90.9703 23.3384 96 35.4178 96 48C96 60.5822 90.9703 72.6616 81.9933 81.6386C73.0163 90.6156 60.8096 95.7727 48 96C35.1904 95.7727 22.9837 90.6156 14.0067 81.6386C5.02969 72.6616 0 60.5822 0 48C0 35.4178 5.02969 23.3384 14.0067 14.3614C22.9837 5.3844 35.1904 0.227335 48 0ZM37.8499 63.5925L25.8805 51.8269C24.9007 50.8614 24.3506 49.5538 24.3506 48.1907C24.3506 46.8276 24.9007 45.52 25.8805 44.5544C26.8652 43.5932 28.1972 43.0536 29.5857 43.0536C30.9741 43.0536 32.3061 43.5932 33.2909 44.5544L41.7227 52.8457L62.7091 32.2351C63.6923 31.2729 65.0237 30.7326 66.4117 30.7326C67.7997 30.7326 69.1311 31.2729 70.1142 32.2351C71.0927 33.2013 71.6419 34.5086 71.6419 35.8713C71.6419 37.2341 71.0927 38.5414 70.1142 39.5076L45.4199 63.7597C44.9186 64.2495 44.3218 64.6348 43.6651 64.8925C43.0085 65.1502 42.3056 65.275 41.5987 65.2594C40.8917 65.2438 40.1953 65.0881 39.5511 64.8016C38.9069 64.5152 38.3283 64.1039 37.8499 63.5925Z"
                    fill="#00BA00"
                />
            </svg>

            <h2 class="fw-bold mb-3">
                If there is removal in Business Unit, the related Documents are
                soft deleted (you can restore them if you restore the Business
                Unit).
            </h2>

            <div
                class="d-flex justify-content-center"
                style="margin-bottom: 20px"
            >
                <button
                    type="button"
                    class="btn px-4 py-3"
                    style="
                        width: 204.5px;
                        background-color: #412cc9;
                        color: white;
                        border: none;
                    "
                    @click="openBusinessUnitEditMessage = false"
                >
                    Ok
                </button>
            </div>
        </div>
    </el-dialog>

    <!-- New Dialog for Document Handling -->
    <el-dialog
        v-model="openDocumentHandlingDialog"
        class="request-doc-dialog client-dialog standalone-dialog document-handling-dialog"
        align-center
        title="Handle Documents for Removed Business Units"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeDocumentDialog"
        destroy-on-close
    >
        <div class="row g-3">
            <div v-if="documentsToHandle.length > 0">
                <div class="mb-3">
                    <P class="alert">
                        Please choose how to handle each document below:
                    </P>
                </div>

                <div class="table-responsive">
                    <table class="table" border="1">
                        <thead class="table-light">
                            <tr>
                                <th class="header-cell">Document Title</th>
                                <th class="header-cell">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(doc, index) in documentsToHandle"
                                :key="doc.id"
                                class="border-bottom"
                            >
                                <td>
                                    <p class="mt-2 doc-title">{{ doc.title }}</p>
                                </td>
                                <td>
                                    <form-el-select
                                        name="selectedAction"
                                        :options="availableBusinessUnitsActions"
                                        :model="doc"
                                        :required="true"
                                        :multiple="false"
                                        :clearable="false"
                                        @change="
                                            (val) => onActionChange(doc, val)
                                        "
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="d-flex justify-content-between mt-4 px-2">
                    <button
                        type="button"
                        class="btn btn-light"
                        @click="closeDocumentDialog"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="confirmDocumentActions"
                        :disabled="!allDocumentsHaveActions"
                    >
                        Confirm Changes
                    </button>
                </div>
            </div>

            <div v-else class="text-center">
                <p>No documents found for the removed business units.</p>
                <button
                    type="button"
                    class="btn px-4 py-3"
                    style="
                        background-color: #412cc9;
                        color: white;
                        border: none;
                    "
                    @click="closeDocumentDialog"
                >
                    OK
                </button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, watch, onMounted, nextTick, computed } from "vue";
import { ElNotification } from "element-plus";
import DeleteIcon from "@/assets/svg/delete-icon.svg?component";
import BusinessDomainsApi from "@api/business_domains.api";
import ProjectsApi from "@api/projects.api";
const props = defineProps({
    project: {
        type: Object,
        default: () => ({}),
    },
    v$: {
        type: Object,
        default: null,
    },
    formErrors: {
        type: Object,
        default: () => ({}),
    },
    businessUnitsForSelect: {
        type: Array,
        default: () => [],
    },
    serviceOfferingForSelect: {
        type: Array,
        default: () => [],
    },
    // businessDomainsForSelect: {
    //     type: Array,
    //     default: () => [],
    // },
    digitalSolutionForSelect: {
        type: Array,
        default: () => [],
    },
    serviceLinesForSelect: {
        type: Array,
        default: () => [],
    },
    managedServiceForSelect: {
        type: Array,
        default: () => [],
    },
    documentTypesForSelect: {
        type: Array,
        default: () => [],
    },
    hasDuplicateTracks: {
        type: Boolean,
        default: false,
    },
    isUpdateForm: {
        type: Boolean,
        default: false,
    },
});

const deleteTrack = (index) => {
    props.project.tracks.splice(index, 1);
    props.project.tracksCount--;
    if (props.project.tracksCount < 1) {
        props.project.has_multiple_tracks = false;
    }
    props.project?.track_ids?.splice(index, 1);
};

if (!Array.isArray(props.project.tracks)) {
    props.project.tracks = [];
}
// Provide Vuelidate-shaped errors for each track input based on parent state
function trackInputErrors(idx) {
    const needsValue =
        props.project?.has_multiple_tracks === true &&
        Number.isInteger(props.project?.tracksCount) &&
        idx >= 0 &&
        idx < (props.project?.tracksCount || 0);
    const raw = props.project?.tracks?.[idx];
    const val = typeof raw === "string" ? raw.trim() : (raw?.name || "").trim();
    const isEmpty = !val;
    // Show error only after parent touched tracks-related fields
    const isTouched = Boolean(
        props.v$?.tracks?.$dirty || props.v$?.tracksCount?.$dirty,
    );
    const invalid = needsValue && isEmpty && isTouched;
    return {
        $error: invalid,
        $errors: invalid ? [{ $message: "This field is required" }] : [],
    };
}
// Watch for changes in has_multiple_tracks and set default tracksCount
watch(
    () => props.project.has_multiple_tracks,
    (newValue) => {
        if (
            newValue === true &&
            (!props.project.tracksCount || props.project.tracksCount < 1)
        ) {
            props.project.tracksCount = 1;
        }
    },
    { immediate: true },
);

const businessDomainsForSelect = ref([]);
const requiredDomainIds = ref([]);

watch(
    () => props.project.offering_ids,
    (newValue) => {
        if (!newValue || newValue.length === 0) {
            businessDomainsForSelect.value = [];
            props.project.business_domain_ids = [];
            requiredDomainIds.value = [];
            return;
        }

        BusinessDomainsApi.getDomainsByOfferings({
            offering_ids: newValue,
        }).then((response) => {
            businessDomainsForSelect.value = [];
            response.data.data.domains.forEach((domain) => {
                businessDomainsForSelect.value.push({
                    id: domain.id,
                    name: domain.name,
                });
            });

            // Store required domain IDs
            requiredDomainIds.value = businessDomainsForSelect.value.map(
                (domain) => domain.id,
            );

            // Update business_domain_ids, but preserve any that are still required
            const currentDomainIds = props.project.business_domain_ids || [];
            const newDomainIds = businessDomainsForSelect.value.map(
                (domain) => domain.id,
            );

            // Keep domains that are still required, add new required ones
            const preservedDomains = currentDomainIds.filter((id) =>
                newDomainIds.includes(id),
            );
            props.project.business_domain_ids = [
                ...new Set([...preservedDomains, ...newDomainIds]),
            ];
        });
    },
    { immediate: true },
);
const availableBusinessUnitsActions = computed(() => {
    const currentAvailable = availableBusinessUnits.value;

    return [
        { id: "delete", name: "Delete" },
        ...currentAvailable.map((bu) => ({
            id: `move_${bu.id}`,
            name: `Move to ${bu.name}`,
        })),
    ];
});
function handleBusinessDomainDeselected(domainId) {
    if (requiredDomainIds.value.includes(domainId)) {
        nextTick(() => {
            if (!props.project.business_domain_ids) {
                props.project.business_domain_ids = [];
            }
            // Ensure the domain is in the array
            if (!props.project.business_domain_ids.includes(domainId)) {
                props.project.business_domain_ids.push(domainId);
            }
        });
    }
}

watch(
    () => props.project.business_domain_ids,
    (newValue, oldValue) => {
        // Only check if we have required domains
        if (requiredDomainIds.value.length === 0) {
            return;
        }

        // Check if any required domain was removed
        const removedDomains = (oldValue || []).filter(
            (id) =>
                requiredDomainIds.value.includes(id) &&
                !(newValue || []).includes(id),
        );

        if (removedDomains.length > 0) {
            // Restore removed required domains
            nextTick(() => {
                if (!props.project.business_domain_ids) {
                    props.project.business_domain_ids = [];
                }
                // Add back any required domains that were removed
                removedDomains.forEach((domainId) => {
                    if (!props.project.business_domain_ids.includes(domainId)) {
                        props.project.business_domain_ids.push(domainId);
                    }
                });
            });
        }
    },
    { deep: true },
);

// Function to disable end dates before start date
const disabledEndDate = (date) => {
    if (!props.project.start_date) {
        return false; // Allow all dates if no start date is selected
    }

    const startDate = new Date(props.project.start_date);
    const currentDate = new Date(date);

    // Disable dates that are before or equal to the start date
    return currentDate <= startDate;
};

// Watch for start date changes and clear end date if it becomes invalid
watch(
    () => props.project.start_date,
    (newStartDate) => {
        if (newStartDate && props.project.end_date) {
            const startDate = new Date(newStartDate);
            const endDate = new Date(props.project.end_date);

            // If end date is now before or equal to the new start date, clear it
            if (endDate <= startDate) {
                props.project.end_date = null;
            }
        }
    },
);

const openBusinessUnitEditMessage = ref(false);
const openedBeforeBUEditMessage = ref(false);

// New variables for document handling
const openDocumentHandlingDialog = ref(false);
const documentsToHandle = ref([]);
const removedBusinessUnits = ref([]);
const availableBusinessUnits = ref([]);

// Variables for confirmation flow
const pendingBusinessUnitChange = ref(null);
const workingProject = ref(null); // Working copy for temporary changes
const preventBusinessUnitUpdate = ref(false);

// Computed property to check if all documents have actions selected
const allDocumentsHaveActions = computed(() => {
    return (
        documentsToHandle.value.length > 0 &&
        documentsToHandle.value.every((doc) => doc.selectedAction)
    );
});

function editBusinessUnitMessage() {
    if (openedBeforeBUEditMessage.value || !props.isUpdateForm) {
        // Already opened once, do nothing
        return;
    }

    openBusinessUnitEditMessage.value = true;
    openedBeforeBUEditMessage.value = true;
}

// New functions for document handling
function handleBusinessUnitChange(deselectedBU) {
    // Only handle document fetching in edit mode
    if (!props.isUpdateForm) {
        // In create mode, just allow normal deselection without document handling
        return;
    }

    // 1. Identify what was removed
    const removedBUs = Array.isArray(deselectedBU)
        ? deselectedBU
        : [deselectedBU];

    // Store in our tracking variable for the dialog and potential rollback
    removedBusinessUnits.value = removedBUs;

    // Get remaining BUs to populate the "Move to" dropdown in the dialog
    const remainingBUs = props.project.business_units || [];
    availableBusinessUnits.value = props.businessUnitsForSelect.filter((bu) =>
        remainingBUs.includes(bu.id),
    );

    // 2. Check for impacted documents
    fetchDocumentsForRemovedBU();
}
function handleBusinessUnitSelected(selectedBU) {
    // Only handle document action cleanup in edit mode
    if (!props.isUpdateForm) {
        return;
    }

    console.log("Business unit selected:", selectedBU);

    // Clean up document actions for documents that belong to re-selected business units
    const selectedBUs = Array.isArray(selectedBU) ? selectedBU : [selectedBU];

    if (
        props.project.document_actions &&
        props.project.document_actions.length > 0
    ) {
        console.log(
            "Current document actions before cleanup:",
            props.project.document_actions,
        );
        // Remove document actions that were created when these BUs were deselected
        // We need to track which documents had actions for which BUs
        cleanupDocumentActionsForSelectedBUs(selectedBUs);
    }
}
async function cleanupDocumentActionsForSelectedBUs(selectedBUs) {
    try {
        if (
            !props.project.document_actions ||
            props.project.document_actions.length === 0
        ) {
            console.log("No document actions to clean up");
            return;
        }

        const originalActionsCount = props.project.document_actions.length;
        console.log("Cleaning up actions for re-selected BUs:", selectedBUs);
        console.log(
            "Actions before cleanup:",
            JSON.parse(JSON.stringify(props.project.document_actions)),
        );

        // Remove document actions for documents whose original business unit is being re-selected
        props.project.document_actions = props.project.document_actions.filter(
            (action) => {
                // Keep the action if the original business unit is NOT in the re-selected BUs
                // Remove the action if the original business unit IS in the re-selected BUs
                const shouldKeepAction = !selectedBUs.includes(
                    action.original_business_unit_id,
                );
                if (!shouldKeepAction) {
                    console.log(
                        "Removing action for document:",
                        action.document_id,
                        "from original BU:",
                        action.original_business_unit_id,
                    );
                }
                return shouldKeepAction;
            },
        );

        const remainingActionsCount = props.project.document_actions.length;
        const removedCount = originalActionsCount - remainingActionsCount;

        console.log(
            "Actions after cleanup:",
            JSON.parse(JSON.stringify(props.project.document_actions)),
        );
        console.log(
            `Cleaned up ${removedCount} document actions for re-selected business units:`,
            selectedBUs,
        );
    } catch (error) {
        console.error(
            "Error cleaning up document actions for selected BUs:",
            error,
        );
        // As a safety measure, clear all actions if cleanup fails
        props.project.document_actions = [];
    }
}
function handleBusinessUnitChangePrevented(newValue) {
    // This is called when the update was prevented - we can ignore since we're handling it manually
    console.log("Business unit change prevented, new value:", newValue);
}

async function fetchDocumentsForRemovedBU() {
    try {
        const response = await ProjectsApi.getDocumentsByBusinessUnits(
            props.project.id,
            {
                business_unit_ids: removedBusinessUnits.value,
            },
        );

        if (
            response.data &&
            response.data.data &&
            response.data.data.documents &&
            response.data.data.documents.length > 0
        ) {
            documentsToHandle.value = response.data.data.documents.map(
                (doc) => ({
                    ...doc,
                    selectedAction:
                        availableBusinessUnitsActions.value[0]?.id || null,
                }),
            );
            // 3. Documents found: Open the dialog and WAIT for user confirmation
            openDocumentHandlingDialog.value = true;
        } else {
            // No documents impacted, allow the deselection to proceed normally
            // ElNotification({
            //     title: 'Success',
            //     message: 'Business units updated successfully.',
            //     type: 'success'
            // });
            // Clear tracking
            removedBusinessUnits.value = [];
        }
    } catch (error) {
        console.error("Error fetching documents:", error);
        // On error, we should rollback to be safe
        rollbackBusinessUnitChange();
        // ElNotification({
        //     title: 'Error',
        //     message: 'Failed to fetch documents. Change reverted.',
        //     type: 'error'
        // });
    }
}
function rollbackBusinessUnitChange() {
    if (removedBusinessUnits.value.length > 0) {
        removedBusinessUnits.value.forEach((id) => {
            // Push the ID back into the project array if it's missing
            if (!props.project.business_units.includes(id)) {
                props.project.business_units.push(id);
            }
        });
    }
}
function getCurrentBUName(buId) {
    const bu = props.businessUnitsForSelect.find((b) => b.id === buId);
    return bu ? bu.name : "Unknown";
}

function onActionChange(doc, newValue) {
    // Ensure the selected action is properly set
    console.log("Action changed for document:", doc.id, "New value:", newValue);
    // The v-model should handle this automatically, but we can add additional logic here if needed
}
function closeDocumentDialog() {
    // 4. ROLLBACK: User cancelled, restore the selection in the UI
    rollbackBusinessUnitChange();

    // Reset states
    openDocumentHandlingDialog.value = false;
    documentsToHandle.value = [];
    removedBusinessUnits.value = [];
}
async function confirmDocumentActions() {
    try {
        // Check if all documents have actions selected
        const documentsWithoutActions = documentsToHandle.value.filter(
            (doc) => !doc.selectedAction,
        );

        if (documentsWithoutActions.length > 0) {
            ElNotification({
                title: "Validation Error",
                message:
                    "Please select an action for all documents before confirming.",
                type: "warning",
            });
            return;
        }

        const actions = documentsToHandle.value.map((doc) => ({
            document_id: doc.id,
            action: doc.selectedAction.startsWith("move_")
                ? "move"
                : doc.selectedAction,
            target_business_unit_id: doc.selectedAction.startsWith("move_")
                ? parseInt(doc.selectedAction.replace("move_", ""))
                : null,
            original_business_unit_id: doc.business_unit_id, // Track the original BU
        }));

        if (!props.project.document_actions) {
            props.project.document_actions = [];
        }
        props.project.document_actions.push(...actions);

        // ElNotification({
        //     title: 'Success',
        //     message: 'Document actions saved.',
        //     type: 'success'
        // });

        // 5. CONFIRM: Do NOT rollback. The change is accepted. Close dialog and reset.
        openDocumentHandlingDialog.value = false;
        documentsToHandle.value = [];
        removedBusinessUnits.value = [];
    } catch (error) {
        console.error("Error saving document actions:", error);
    }
}

// --- Normalize dates on edit mode -----------------------------------------
function toYMD(value) {
    if (!value) return value;
    if (typeof value === "string") {
        const trimmed = value.trim();
        // If already YYYY-MM-DD at start
        const ymd = trimmed.match(/^(\d{4}-\d{2}-\d{2})/);
        if (ymd) return ymd[1];

        // 01/02/2023 (DD/MM/YYYY or MM/DD/YYYY) – given API uses DD/MM/YYYY
        const dmySlash = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (dmySlash) {
            const day = dmySlash[1];
            const month = dmySlash[2];
            const year = dmySlash[3];
            return `${year}-${month}-${day}`;
        }

        // 01 Feb, 2023
        const dMonY = trimmed.match(/^(\d{2})\s([A-Za-z]{3}),\s(\d{4})$/);
        if (dMonY) {
            const day = dMonY[1];
            const mon = dMonY[2].toLowerCase();
            const year = dMonY[3];
            const map = {
                jan: "01",
                feb: "02",
                mar: "03",
                apr: "04",
                may: "05",
                jun: "06",
                jul: "07",
                aug: "08",
                sep: "09",
                oct: "10",
                nov: "11",
                dec: "12",
            };
            if (map[mon]) return `${year}-${map[mon]}-${day}`;
        }

        // 01 February, 2023
        const dMonthY = trimmed.match(/^(\d{2})\s([A-Za-z]+),\s(\d{4})$/);
        if (dMonthY) {
            const day = dMonthY[1];
            const month = dMonthY[2].toLowerCase();
            const year = dMonthY[3];
            const map = {
                january: "01",
                february: "02",
                march: "03",
                april: "04",
                may: "05",
                june: "06",
                july: "07",
                august: "08",
                september: "09",
                october: "10",
                november: "11",
                december: "12",
            };
            return `${year}-${map[month]}-${day}`;
        }

        // Fall back to Date parsing
        const d = new Date(trimmed);
        if (!isNaN(d.getTime())) return d.toISOString().slice(0, 10);
        return value;
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
        return value.toISOString().slice(0, 10);
    }
    return value;
}

// Normalize incoming values on mount (edit mode)
onMounted(() => {
    if (props.project) {
        if (props.project.start_date) {
            props.project.start_date = toYMD(props.project.start_date);
        }
        if (props.project.end_date) {
            props.project.end_date = toYMD(props.project.end_date);
        }
        if (props.project?.businessDomains) {
            props.project?.businessDomains?.forEach((domain) => {
                businessDomainsForSelect.value.push({
                    id: domain.id,
                    name: domain.name,
                });
            });
            props.project.business_domain_ids =
                businessDomainsForSelect.value.map((domain) => domain.id);
        }

        // In edit mode, populate required domains based on current offerings
        // Note: The watch with immediate: true will handle loading domains when navigating back
        if (
            props.isUpdateForm &&
            props.project.offering_ids &&
            props.project.offering_ids.length > 0
        ) {
            BusinessDomainsApi.getDomainsByOfferings({
                offering_ids: props.project.offering_ids,
            }).then((response) => {
                const domains = response.data.data.domains || [];
                requiredDomainIds.value = domains.map((domain) => domain.id);
            });
        }
    }
});

// Keep normalized if parent updates during edit
watch(
    () => props.project.start_date,
    (val) => {
        const normalized = toYMD(val);
        if (normalized !== val) props.project.start_date = normalized;
    },
);
watch(
    () => props.project.end_date,
    (val) => {
        const normalized = toYMD(val);
        if (normalized !== val) props.project.end_date = normalized;
    },
);
</script>

<style scoped>
/* Fix dropdown positioning in document handling dialog */
.document-handling-dialog :deep(.el-select-dropdown) {
    z-index: 3000 !important;
    position: fixed !important;
}

.document-handling-dialog :deep(.el-popper) {
    z-index: 3000 !important;
}

.document-handling-dialog :deep(.el-select) {
    position: relative;
}

.document-handling-dialog :deep(.el-select .el-input__wrapper) {
    position: relative;
    z-index: 1;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
    background: #fff;
    transition:
        border-color 0.15s ease,
        box-shadow 0.15s ease;
}

.document-handling-dialog :deep(.el-select .el-input__wrapper:hover) {
    border-color: #9b8cff;
}

.document-handling-dialog :deep(.el-select.is-focus .el-input__wrapper) {
    border-color: #9b8cff;
    box-shadow: 0 0 0 3px rgba(155, 140, 255, 0.25);
}

.document-handling-dialog :deep(.el-select .el-input__inner) {
    font-size: 14px;
    color: #374151;
    font-weight: 500;
}

.option-card {
    width: 228.5px;
    height: 40px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition:
        box-shadow 0.15s ease,
        border-color 0.15s ease;
    background: #fff;
}

.option-card:focus-within,
.option-card:hover {
    box-shadow:
        inset 0 0 0 2px #9b8cff,
        0 0 0 3px rgba(155, 140, 255, 0.25);
}

.option-card.is-selected {
    box-shadow: inset 0 0 0 2px #9b8cff;
}

.option-label {
    font-weight: 500;
}

.option-radio {
    width: 22px;
    height: 22px;
    border: 2px solid #cbd5e1;
    border-radius: 50%;
    position: relative;
    flex-shrink: 0;
}

.option-card.is-selected .option-radio::after {
    content: "";
    position: absolute;
    inset: 3px;
    background: #111827;
    border-radius: 50%;
}

.visually-hidden {
    position: absolute !important;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

/* Duplicate tracks warning styling */
.duplicate-tracks-warning .alert {
    border: 1px solid #fbbf24;
    background-color: #fef3c7;
    color: #92400e;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 0;
    animation: slideIn 0.3s ease-out;
}

.duplicate-tracks-warning .alert svg {
    color: #f59e0b;
    flex-shrink: 0;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.track-input-wrapper {
    position: relative;
}

.delete-icon-container {
    flex-shrink: 0;
    padding-top: 2.5rem;
    display: flex;
    align-items: flex-start;
}

.delete-icon-container :deep(svg) {
    color: #dc3545;
    transition: color 0.2s ease;
}

.delete-icon-container :deep(svg:hover) {
    color: #c82333;
}

.delete-icon-container svg {
    height: 24px !important;
}

.header-cell {
    font-weight: bold;
    font-size: 14px;
    color: #46454D;
}

.doc-title {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
}
.alert{
    font-size: 16px;
    color: #000000;
    font-weight: 500;
}
</style>
